"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    getStyle: function() {
        return getStyle;
    },
    getStyleForShow: function() {
        return getStyleForShow;
    },
    getStyleForWrestler: function() {
        return getStyleForWrestler;
    }
});
const getStyleForWrestler = (item)=>getStyle(item === null || item === void 0 ? void 0 : item.brand);
const getStyleForShow = (item)=>{
    var _item_brands;
    const active = (item === null || item === void 0 ? void 0 : (_item_brands = item.brands) === null || _item_brands === void 0 ? void 0 : _item_brands[0]) || null;
    return getStyle(active);
};
const getStyle = (item)=>{
    let { color = false, backgroundColor = false } = item;
    if (!color || !backgroundColor) {
        var _item_brand, _item_brands_, _item_brands, _item_show, _item_championship, _item_championships_, _item_championships, _item_brand1, _item_brands_1, _item_brands1, _item_show1, _item_championship1, _item_championships_1, _item_championships1;
        color = (item === null || item === void 0 ? void 0 : (_item_brand = item.brand) === null || _item_brand === void 0 ? void 0 : _item_brand.color) || (item === null || item === void 0 ? void 0 : (_item_brands = item.brands) === null || _item_brands === void 0 ? void 0 : (_item_brands_ = _item_brands[0]) === null || _item_brands_ === void 0 ? void 0 : _item_brands_.color) || (item === null || item === void 0 ? void 0 : (_item_show = item.show) === null || _item_show === void 0 ? void 0 : _item_show.color) || (item === null || item === void 0 ? void 0 : (_item_championship = item.championship) === null || _item_championship === void 0 ? void 0 : _item_championship.color) || (item === null || item === void 0 ? void 0 : (_item_championships = item.championships) === null || _item_championships === void 0 ? void 0 : (_item_championships_ = _item_championships[0]) === null || _item_championships_ === void 0 ? void 0 : _item_championships_.color);
        backgroundColor = (item === null || item === void 0 ? void 0 : (_item_brand1 = item.brand) === null || _item_brand1 === void 0 ? void 0 : _item_brand1.backgroundColor) || (item === null || item === void 0 ? void 0 : (_item_brands1 = item.brands) === null || _item_brands1 === void 0 ? void 0 : (_item_brands_1 = _item_brands1[0]) === null || _item_brands_1 === void 0 ? void 0 : _item_brands_1.backgroundColor) || (item === null || item === void 0 ? void 0 : (_item_show1 = item.show) === null || _item_show1 === void 0 ? void 0 : _item_show1.backgroundColor) || (item === null || item === void 0 ? void 0 : (_item_championship1 = item.championship) === null || _item_championship1 === void 0 ? void 0 : _item_championship1.backgroundColor) || (item === null || item === void 0 ? void 0 : (_item_championships1 = item.championships) === null || _item_championships1 === void 0 ? void 0 : (_item_championships_1 = _item_championships1[0]) === null || _item_championships_1 === void 0 ? void 0 : _item_championships_1.backgroundColor);
    }
    return {
        backgroundColor,
        color
    };
};
const _default = getStyle;
